// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LmE6","colMin":"styles_colMin__1dOhw"};